
import { defineComponent } from 'vue'
import { getFormattingFn } from '@madxnl/mrrabbit'
import BaseListPage from '@madxnl/mrrabbit/dist/Home'

type FieldMetaData = { formatting?: string }

export default defineComponent({
  ...(BaseListPage as any),
  methods: {
    ...(BaseListPage as any).methods,
    async otherFetch(ids?: string[]) {
      const context = this as any
      try {
        await (BaseListPage as any).methods.otherFetch.call(this, ids)
      } catch (error) {
        // Mrrabbit swallows GraphQL errors, then dereferences the missing rows.
        // Resolve the pending fetch so the next search can recover normally.
        context.objects = []
        context.totalResults = 0
        context.$toast.add({
          severity: 'error',
          summary: 'Could not load results',
          detail: 'The server could not complete this request. Please try again.',
          life: 5000,
        })
      } finally {
        context.loading = false
      }
    },
    // dist/Home bundles its own formatter registry, which only knows "date".
    // Custom formatters such as "decimal" are registered through the package
    // entry point, so look them up there and fall back to the raw value.
    formatField(value: unknown, fieldMetaData: FieldMetaData) {
      if (fieldMetaData?.formatting == null) return value
      const formattingFn = getFormattingFn(fieldMetaData.formatting)
      if (typeof formattingFn === 'function') return formattingFn(value)
      try {
        return (BaseListPage as any).methods.formatField.call(this, value, fieldMetaData)
      } catch {
        return value
      }
    },
  },
})
